import { CreatableSelect, CreatableSelectProps } from './CreatableSelect';
import { LabelSelect, LabelSelectProps } from './LabelSelect';
import { MultipleSelect, MultipleSelectProps } from './MultipleSelect';
import { SelectProps, SingleSelect } from './SingleSelect';
import { CreatableMultipleSelect, CreatableMultipleSelectProps } from './CreatableMultipleSelect';
import { SelectTypes } from './types';
export type { Option } from './types';
export { SelectTypes } from './types';

type ExtendedMultipleSelectProps<T = string | null> = MultipleSelectProps<T> & {
  selectType: SelectTypes.MultipleSelect;
};

type ExtendedSingleSelectProps<T = string | null> = SelectProps<T> & {
  selectType: SelectTypes.SingleSelect;
};

type ExtendedLabelSelectProps = LabelSelectProps & {
  selectType: SelectTypes.LabelSelect;
};

type ExtendedCreatableSelectProps<T = string | null> = CreatableSelectProps<T> & {
  selectType: SelectTypes.CreatableSelect;
};

type ExtendedCreatableMultipleSelectProps<T = string | null> = CreatableMultipleSelectProps<T> & {
  selectType: SelectTypes.CreatableMultipleSelect;
};

type Props<T = string | null> = (
  | ExtendedMultipleSelectProps<T>
  | ExtendedSingleSelectProps<T>
  | ExtendedLabelSelectProps
  | ExtendedCreatableSelectProps<T>
  | ExtendedCreatableMultipleSelectProps<T>
) & { key?: React.Key | null };

export const SelectFactory = <T = string | null>(props: Props<T>) => {
  switch (props.selectType) {
    case SelectTypes.MultipleSelect:
      return <MultipleSelect {...props} />;
    case SelectTypes.SingleSelect:
      return <SingleSelect {...props} />;
    case SelectTypes.LabelSelect:
      return <LabelSelect {...props} />;
    case SelectTypes.CreatableSelect:
      return <CreatableSelect {...props} />;
    case SelectTypes.CreatableMultipleSelect:
      return <CreatableMultipleSelect {...props} />;
    default:
      return <></>;
  }
};
